import UiModal from '../../../../js/components/UiModal/UiModal';
import Form from '../../../../js/Form/Form';
import { defaultRules } from '../../../../js/Form/default-rules';
import { showAlchemerePopup } from '../../../../js/components/Alchemere';

export class AutopaymentModal extends UiModal {
  constructor(template) {
    super(template, {
      wrapperClass: 'autopayment-popup'
    });

    this.form = null;

    this._formSendedHandler = this._formSendedHandler.bind(this);
    this._formChangeHandler = this._formChangeHandler.bind(this);
    this._formSubmitHandler = this._formSubmitHandler.bind(this);
  }

  beforeMounted() {
    this.form = this.element.querySelector('.form');
    const paymentForm = new Form(this.form, { accept: defaultRules.accept });
    paymentForm.init();

    paymentForm.onCloudPayment = this._formSendedHandler;
    paymentForm.onFormSend = this._formSendedHandler;

    this.form.addEventListener('change', this._formChangeHandler)
    this.form.addEventListener('form-sended', this._formSubmitHandler)
  }

  beforeUnmounted() {
    this.form.removeEventListener('change', this._formChangeHandler)
    this.form.removeEventListener('form-sended', this._formSubmitHandler)
  }

  _formSendedHandler() {
    this.close();
  }

  _formChangeHandler(evt) {
    window.$analytics?.push('autopayment-modal-type-change', {
      label: evt.target.dataset.analytics
    });
  }

  _formSubmitHandler(evt) {
    const chosenType = evt.target.querySelector('input:checked');

    window.$analytics?.push('autopayment-modal-type-submit', {
      label: chosenType?.dataset.analytics || 'Cloudpayments'
    });
  }

  beforeClose() {
    showAlchemerePopup('lead');
  }
}
